var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("page-title-area", [_c("h1", [_vm._v(_vm._s(_vm.$t("title")))])]),
      _vm._v(" "),
      !_vm.loading && _vm.places.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-end mb-4" },
            [
              _c(
                "round-button",
                {
                  attrs: { icon: "add_circle", "data-testid": "create_button" },
                  on: {
                    click: function ($event) {
                      return _vm.openEditor(null)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("button.create")) + "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.places.length === 0
        ? _c("r-type-place-empty-state", {
            on: {
              create: function ($event) {
                return _vm.openEditor(null)
              },
            },
          })
        : _c("r-type-place-table", {
            attrs: {
              places: _vm.places,
              sensors: _vm.sensors,
              loading: _vm.loading,
            },
            on: { edit: _vm.openEditor, delete: _vm.confirmDelete },
          }),
      _vm._v(" "),
      _c("r-type-place-editor", {
        attrs: { place: _vm.editTarget },
        on: { saved: _vm.onSaved },
        model: {
          value: _vm.editorVisible,
          callback: function ($$v) {
            _vm.editorVisible = $$v
          },
          expression: "editorVisible",
        },
      }),
      _vm._v(" "),
      _c("confirm-dialog", {
        attrs: {
          message: _vm.$t("confirm_delete", {
            placeName: _vm.deleteTarget.name,
          }),
        },
        on: {
          yes: function ($event) {
            return _vm.deletePlace(_vm.deleteTarget)
          },
        },
        model: {
          value: _vm.deleteConfirmDialogVisible,
          callback: function ($$v) {
            _vm.deleteConfirmDialogVisible = $$v
          },
          expression: "deleteConfirmDialogVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }